"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var messages = {
  read: function read() {
    var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return this.action().read(conditions, options);
  }
};

exports.messages = messages;